export enum ErrorType {
  ArchiveStrategyWithActiveVersionDisallowed = 'ARCHIVE_STRATEGY_WITH_ACTIVE_VERSION_DISALLOWED',
  DeleteStrategyWithLockedVersionDisallowed = 'DELETE_STRATEGY_WITH_LOCKED_VERSION_DISALLOWED',
  ArchiveActiveVersionDisallowed = 'ARCHIVE_ACTIVE_VERSION_DISALLOWED',
  DeleteLockedVersionDisallowed = 'DELETE_LOCKED_VERSION_DISALLOWED',
  CopyStrategyWithoutModules = 'COPY_STRATEGY_WITHOUT_MODULES_DISALLOWED',
}
